import React from 'react';
import { FiGift } from 'react-icons/fi';
import styles from '../DonationForm.module.css';
import OneTimeAmountFields from './OneTimeAmountFields';
import MonthlyAmountFields from './MonthlyAmountFields';

// The Donation Amount section (one-time amount input + quick-shortcuts, OR
// monthly amount + number-of-payments/forever). Extracted VERBATIM from
// DonationForm's render.
export default function DonationAmountSection({
  onClientSecretChange, preservedOneTimeAmount, setPreservedOneTimeAmount, clientSecret, donationType,
  isForever, monthlyAmount, numberOfPayments, oneTimeAmount, paymentIntentCreatedRef,
  preservedIsForever, preservedMonthlyAmount, preservedNumberOfPayments, setClientSecret, setIsForever,
  setMonthlyAmount, setNumberOfPayments, setOneTimeAmount, setPaymentIntentId, setPreservedMonthlyAmount,
  setShowPaymentElement, setShowPaymentForm, showPaymentElement, showPaymentForm, user,
}) {
  return (
    <div className={styles.formSection}>
      <h4 className={styles.sectionTitle}>
        <FiGift /> Donation Amount
      </h4>

      {donationType === 'one-time' ? (
        <OneTimeAmountFields
          clientSecret={clientSecret}
          onClientSecretChange={onClientSecretChange}
          oneTimeAmount={oneTimeAmount}
          paymentIntentCreatedRef={paymentIntentCreatedRef}
          preservedOneTimeAmount={preservedOneTimeAmount}
          setClientSecret={setClientSecret}
          setOneTimeAmount={setOneTimeAmount}
          setPaymentIntentId={setPaymentIntentId}
          setPreservedOneTimeAmount={setPreservedOneTimeAmount}
          setShowPaymentElement={setShowPaymentElement}
          setShowPaymentForm={setShowPaymentForm}
          showPaymentElement={showPaymentElement}
          showPaymentForm={showPaymentForm}
        />
      ) : (
        <MonthlyAmountFields
          clientSecret={clientSecret}
          isForever={isForever}
          monthlyAmount={monthlyAmount}
          numberOfPayments={numberOfPayments}
          onClientSecretChange={onClientSecretChange}
          paymentIntentCreatedRef={paymentIntentCreatedRef}
          preservedIsForever={preservedIsForever}
          preservedMonthlyAmount={preservedMonthlyAmount}
          preservedNumberOfPayments={preservedNumberOfPayments}
          setClientSecret={setClientSecret}
          setIsForever={setIsForever}
          setMonthlyAmount={setMonthlyAmount}
          setNumberOfPayments={setNumberOfPayments}
          setPaymentIntentId={setPaymentIntentId}
          setPreservedMonthlyAmount={setPreservedMonthlyAmount}
          setShowPaymentElement={setShowPaymentElement}
          setShowPaymentForm={setShowPaymentForm}
          showPaymentForm={showPaymentForm}
        />
      )}
    </div>
  );
}
